import { render, staticRenderFns } from "./ApplicationCenterTable.vue?vue&type=template&id=4ce3e7cd&scoped=true&"
import script from "./ApplicationCenterTable.vue?vue&type=script&lang=js&"
export * from "./ApplicationCenterTable.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationCenterTable.vue?vue&type=style&index=0&id=4ce3e7cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce3e7cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VIcon,VSimpleTable})
